import { Component, OnInit, Input, Output, EventEmitter , ChangeDetectorRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { GeoZoneService } from '../../../../../services/geo_zone/geo_zone.service';
import { LoginService } from '../../../../../services/login/login.service';
import { Loginshared } from '../../../../../services/sharedservices/loginshared.service';
import { FormBuilder, FormGroup, FormArray,Validators } from '@angular/forms';
import { errorMessages } from './../../../././././../../configurations/errorMessages';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../services/common_Service/common.service';
import {SessionHelper} from '../../../../../services/localstorage';


@Component({
  selector: 'app-addGeoZone',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentGeoZone implements OnInit {

    isCreateNewShow:boolean = true;
    contentReadyToReview:boolean= false;
    shareMassage :any;
    isUserLoggedIn:boolean;
    createGeoZoneForm:FormGroup;
    isGeoZoneSubmitted:boolean=false;
    geoMapping:any={};
    mapping:any=[];
    globalContinentSettings={};
    globalCountrySettings={};
    globalContinentList=[];
    globalCountryList=[];
    geoZoneList=[];

    errorMessages = errorMessages;
    loader:boolean=false;

    update:boolean=false;
    id:any;

    //Dynaic fromArray
    variableForm:FormGroup;
    items: FormArray;
    countryFilterObj:any;
    geoMappingFilter:any={};
    geoZoneFormData:any ={};
    geoMappingSelectionFlag:boolean=false;
    filterObj:any = {};
    filtergeoObj:any = {};

    selectedItem = [];

    isDeleteAction: boolean=false;
    deleteGeoMappingIndex:any;


    //@Input() contentId:any;
    @Output() updateSend = new EventEmitter<any>();
    config: { id: 'pagination2',itemsPerPage: number; currentPage: number; totalItems: any; };
    start: any;
    limit: number = 10;
    activecurrentPage: number = 1;
    deleteGeoMapping: any=[];
    searcherrormsg: boolean=false;

   //New Code start
    @Input() set contentId(value: any) {

        this.isGeoZoneSubmitted = false;

        if(value == 'reset'){

            this.resetForm();

        }else {
            //start code for hide create new button
            if(value != 'null'){
                this.showCreateNewButton('hide');
            }
            //end code for hide create new button
            this.onLoad(value);
        }
        
    }
    //New Code end

    editorConfig = {
        "toolbar": [
            ["bold", "italic", "underline"],
            ["justifyLeft", "justifyCenter", "justifyRight"]
        ]
    }
    
    applyBlackTheme = localStorage.getItem('boolThemeFlag');
    
    constructor(private commonService: CommonService, private toastrService: ToastrService, private activatedRoute:ActivatedRoute,private loginSharedService: Loginshared,  private router: Router, private geoZoneService: GeoZoneService, private formBuilder:FormBuilder) {
        loginSharedService.sendUserLoggedIn$.subscribe(mission => {
            this.isUserLoggedIn = mission;
            let uid = localStorage.getItem('ud');
            if (uid !== undefined && uid != null) {
                this.isUserLoggedIn = true;
            }
        });
    }

    roleAsses:any={};
    roleConfiguration:any=[];
    ngOnInit(){
        this.filtergeoObj ={};
        this.config = {
            id: 'pagination2',
            itemsPerPage: 10,
            currentPage: 1,
            totalItems:  0
          };
        this.roleAsses.geoZoneEdit = false;
        this.roleAsses.geoZone = false;
        this.roleAsses.geoZoneCreate = false;

        this.roleConfiguration = SessionHelper.getRole();

           this.roleConfiguration.forEach((element , i) => {

              if((element.isView == 1 && element.pageTitle == 'Geo Zone') ){
                  
                  this.roleAsses.geoZone = true;
              }
          
              if((element.isEdit == 1 && element.pageTitle == 'Geo Zone') ){
                  
                  this.roleAsses.geoZoneEdit = true;
              }
              
              if((element.isCreate == 1 && element.pageTitle == 'Geo Zone')){

                  this.roleAsses.geoZoneCreate = true;
              
              }
            })
        // theme update code start
       this.commonService.currentThemelight.subscribe((result:any)=>{
          
        this.applyBlackTheme = localStorage.getItem('boolThemeFlag');
        
        
     })
    // theme update code start
    }

    editCreate:boolean = false;
    onCreateNew(){
  
          if(this.roleAsses.geoZoneCreate == true){
  
              this.editCreate = true;
          }
          
          this.isCreateNewShow=false
  
    }

    onLoad(id) {

        
        if(id != 'null' && this.roleAsses.geoZoneEdit == true){

            this.editCreate = true;

        }else{

            this.editCreate = false;

        }
        
        // this.geoMapping.mapping[0].globalContinentList=[];
        // this.geoMapping.mapping[0].globalCountryList=[];


        this.geoMappingFilter={};
  
        
        let uid = localStorage.getItem('ud');
        if (uid !== undefined && uid != null) {

        }   else {
            this.router.navigate(['/login']);
        }

        let headerTitle = {
            title:'Master',
            subTitle:'Geo Zone'
        }

        this.commonService.changeHeaderTitle(headerTitle);

        this.createGeoZoneForm = this.formBuilder.group({
            geoZoneName:['', Validators.compose([Validators.required])],
            // latitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            latitude:[''],
            // mapAssetGroup:[[]],
            longitude:[''],
            // longitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            description:[''],
            isActive:['1'],
            mapGeoMapping:[[]],
            deletedGeoMapping:[[]],
            id:[''],
            contentState:['In-Progress'],
            publisherState:['Un-published'],
            reviewerState:['Un-approved'],
            created_by:[localStorage.getItem('ud')],
            

            // geoMappingArray: this.formBuilder.array([ this.createGeoMappingItem() ])
        });
        
        //add dynamic field
        this.variableForm = this.formBuilder.group({
            items: this.formBuilder.array([ this.createItem() ])
        });

        this.globalContinentSettings = {
            singleSelection: true, 
            text:"Select",
            position:'bottom',
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            classes:"myclass custom-class"
        }
        this.globalCountrySettings = {
            singleSelection: true, 
            text:"Select",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            enableSearchFilter: true,
            classes:"myclass custom-class"
        }


        // this.activatedRoute.params.subscribe(params => {

            // this.id = +params['id']; // (+) converts string 'id' to a number
            this.id = id; // (+) converts string 'id' to a number
                if(this.id!='null'){

                    console.log('this.id===>>>',this.id);
                    this.update = true;
                     this.activecurrentPage=1;
                    this.getGeoZoneInfo(this.id,false,0,10)
                    this.getGlobalContinentList(this.geoMappingFilter);
                    this.getGlobalCountryList(this.geoMappingFilter);

                   
                }else{
                    this.getGlobalContinentList(this.geoMappingFilter);
                    //this.getGlobalContinentListNew(this.geoMappingFilter,0);
                    // this.getGlobalCountryListNew(this.geoMappingFilter,0);
                    // this.getGlobalStateListNew(this.geoMappingFilter,0);
                    // this.getGlobalCityListNew(this.geoMappingFilter,0);
                    this.getAllGeoZone(this.filterObj,0,10);
                    this.update = false;
                }

        // });

    }

    onDeSelectAll(event, info, i){
       
       console.log("ranjeet------onDeSelectAll");
       
       
        if(info =='continentId'){
            let objItems = this.variableForm.get('items') as FormArray;
            objItems.controls[i].get('continentId').setValue([]);
            objItems.controls[i].get('countryId').setValue([]);
            
            //this.createGeoZoneForm.controls['continentId'].setValue([]);
        }
        else if(info =='countryId'){
            
            let objItems = this.variableForm.get('items') as FormArray;
            objItems.controls[i].get('countryId').setValue([]);
            //this.createGeoZoneForm.controls['countryId'].setValue([]);
        }
    }


    get l() { return this.createGeoZoneForm.controls; }
    get l_i() {  let objItems =this.variableForm.get('items') as FormArray;return objItems.controls; }

    getAllGeoZone(obj, start, limit){
        this.geoZoneService.getGeoZoneList()
        .subscribe((result:any)=>{
            
            this.geoZoneList = [];
            if(result.data.data.length > 0){
                for (let geoZoneObj of result.data.data) {
                    let isActiveStatus;

                    // if(geoZoneObj.isActive == 1){
                    // geoZoneObj.isActive='Active';
                    //     isActiveStatus = "<span class='activeStatus'>Active</span>";
                    // }else{
                    // geoZoneObj.isActive='Not Active';
                    //     isActiveStatus = "<span class='notactiveStatus'>Not Active</span>";
                    // }
                    this.geoZoneList.push(
                    {
                        'id': geoZoneObj.geoZoneId,
                        'itemName': geoZoneObj.geoZoneName
                        // 'startIP':geoZoneObj.startIP,
                        // 'endIP':geoZoneObj.endIP
                    });
                }
            }
            console.log(this.geoZoneList);
        }) 
    }
    clearFormArray = (formArray: FormArray) => {
        // while (formArray.length !== 0) {
        //   formArray.removeAt(0)
        // }
    }    

    getGeoZoneInfo(id,filter,start,limit){
        console.log(filter)
        if(filter == false){
        this.filterObj = {};
        }    
        this.commonService.changeloader(true);

            this.commonService.changeloader(false);
            this.geoZoneService.getGeoZone(id,this.filtergeoObj,start,limit)
        .subscribe((result:any)=>{
            this.filtergeoObj ={};
            // this.loader=false;
            this.commonService.changeloader(false);
            console.log("result==========>",result);
            this.createGeoZoneForm.controls['geoZoneName'].setValue(result.data[0].geoZoneName);
            this.createGeoZoneForm.controls['latitude'].setValue(result.data[0].latitude);
            this.createGeoZoneForm.controls['longitude'].setValue(result.data[0].longitude);
            this.createGeoZoneForm.controls['description'].setValue(result.data[0].description);
            this.createGeoZoneForm.controls['isActive'].setValue(result.data[0].isActive.toString());

            // console.log("result.data[0].results.geoMapping[0]=========>>>>>>>>... ",result.data[0].geoMapping[0]);

            this.createGeoZoneForm.controls['publisherState'].setValue(result.data[0].publisherState);
            this.createGeoZoneForm.controls['reviewerState'].setValue(result.data[0].reviewerState);
         
            if(result.data[0].contentState == null || result.data[0].contentState == '' || result.data[0].contentState == undefined){
                this.createGeoZoneForm.controls['contentState'].setValue(['In-Progress']);
            }
            else{
                this.createGeoZoneForm.controls['contentState'].setValue(result.data[0].contentState);
            }

            if(result.data[0].geoMapping.length > 0){

                this.variableForm = this.formBuilder.group({
                    items: this.formBuilder.array([])
                });
               // (this.variableForm.controls['other_Partners'] as FormArray).clear();

                this.items = this.variableForm.get('items') as FormArray;
                this.items.reset()
                this.geoZoneFormData=result.data[0].geoMapping;
                this.loader = true
                this.config = {
                    id: 'pagination2',
                    itemsPerPage: 10,
                    currentPage: this.activecurrentPage,
                    totalItems: result.data[0].totalCount 
                  };
                  console.log(result.data[0].geoMapping.length)
                for(let i=0;i<result.data[0].geoMapping.length;i++){

                    setTimeout (() => {

                        console.log("123",result.data[0].geoMapping[i]);

                                this.items.push(this.updateItem(result.data[0].geoMapping[i],i));
                          
                    }, 1000);
                    this.geoZoneFormData[i]['addNewItemFlag']=false;  

                }
                // this.geoZoneFormData=result.data[0].geoMapping;
                this.loader = false
                console.log("===============================================",this.items);

            }
            else {
                this.variableForm = this.formBuilder.group({
                    items: this.formBuilder.array([])
                });
            }
                
        });
    }
    pageChanged(event){

        console.log("event>>",event);


        let pageInfo = [{

          // 'count': 13,
          'limit': 10,
          'offset': event-1,
          'pageSize': 10,
          'id':2

        }] 
        this.activecurrentPage = event;
        console.log("pageInfo",pageInfo);

        if(pageInfo[0].offset === 0){

            this.start =  0;
            this.getGeoZoneInfo(this.id,false,this.start, this.limit)

        }else {
            
            this.start =  (this.limit * (pageInfo[0].offset));
            this.getGeoZoneInfo(this.id,false,this.start, this.limit)
        }

      }
    onItemSelect(item:any, geoMappingName,i){
    
        console.log("ranjeet------ON Item Select");
        /*console.log("Sanjeet",this.variableForm);
        console.log("Items--->",this.variableForm.controls['items']);
        console.log("============",this.variableForm.controls['items'].controls[0]);
        console.log("=======xxx=====",this.variableForm.controls['items'].controls[0].controls['countryId'].setValue([]));
        */
        console.log(item);
        if(geoMappingName == 'continent'){
            
            let objItems = this.variableForm.get('items') as FormArray;
            objItems.controls[i].get('countryId').setValue([]);
            
            this.geoMappingFilter.continentId=item.id;
            // this.getGlobalCountryList(this.geoMappingFilter);
             this.getGlobalCountryListNew(this.geoMappingFilter,i);
        }
        if(geoMappingName == 'country'){
        
            let objItems = this.variableForm.get('items') as FormArray;

            
            this.geoMappingFilter.countryId=item.id;

        }  
    }

    onItemDeSelect(item:any, geoMappingName, i){
        
        console.log("ranjeet------onItemDeSelect");
        
        if(geoMappingName == 'continent'){
            
            let objItems = this.variableForm.get('items') as FormArray;
            objItems.controls[i].get('continentId').setValue([]);
            objItems.controls[i].get('countryId').setValue([]);

            
            this.geoMappingFilter.continentId = [];
            // this.getGlobalCountryList({});
        }
        if(geoMappingName == 'country'){
            
            let objItems = this.variableForm.get('items') as FormArray;
            objItems.controls[i].get('countryId').setValue([]);

            this.geoMappingFilter.countryId = [];
        } 
    }

    onGeoZoneSelect(item:any){
        console.log(item.id);
        // this.createGeoZoneForm.controls['subGeoZoneId']=item.id;
        this.createGeoZoneForm.get('subGeoZoneId').setValue(item.id);    
    }

    onGeoZoneDeSelect(item:any){
        // this.createGeoZoneForm.controls['subGeoZoneId']=[];
        this.createGeoZoneForm.get('subGeoZoneId').setValue(0);    
    }

    getGlobalContinentList(ContinentFilter){

        this.commonService.getGlobalContinentList(ContinentFilter).subscribe((result:any)=>{
            
            this.globalContinentList = [];
            
            if(result.data.data.length > 0){    
                
                this.globalContinentList.push({id: 1, itemName: "All"})

                for (let globalContinentList of result.data.data) {

                    // if(globalContinentList.continentId!='' && globalContinentList.continentId != 1){
                        if(globalContinentList.continentId!='' && globalContinentList.continentId!=1){

                    
                        this.globalContinentList.push(
                        {
                            'id': globalContinentList.continentId,
                            'itemName': globalContinentList.continentName
                        });
                    } 
                }

                console.log("globalContinentList>>",this.globalContinentList);
            } else{
                
                this.globalContinentList.push({id: 1, itemName: "All"})

            }

        });
    }

    getGlobalCountryList(countryFilter){

        this.commonService.getGlobalCountryList(countryFilter).subscribe((result:any)=>{
            
            this.globalCountryList = [];
            
            if(result.data.data.length > 0){  
                
                this.globalCountryList.push({id: 1, itemName: "All"})

                for (let globalCountryList of result.data.data) {

                    // if(globalCountryList.countryId!='' && globalCountryList.countryId != 1){
                        if(globalCountryList.countryId!='' && globalCountryList.continentId!=1){

                    
                        this.globalCountryList.push(
                        {
                            'id': globalCountryList.countryId,
                            'itemName': globalCountryList.countryName
                        });
                    } 
                }
            } else{
                
                this.globalCountryList.push({id: 1, itemName: "All"})

            }

        });
    }


    getGlobalContinentListNew(ContinentFilter,i){
     
        this.mapping[i].globalContinentList=[];
             

    }

    getGlobalCountryListNew(countryFilter,i){

        this.commonService.getGlobalCountryList(countryFilter).subscribe((result:any)=>{
            
            this.mapping[i].globalCountryList=[];
            
            if(result.data.data.length > 0){ 
                
                this.mapping[i].globalCountryList.push({id: 1, itemName: "All"})

                console.log('this.mapping[i]123',this.mapping[i].globalCountryList)

                for (let globalCountryList of result.data.data) {

                    // if(globalCountryList.countryId!='' && globalCountryList.countryId != 1){
                        if(globalCountryList.countryId!='' && globalCountryList.continentId!=1){
                    
                        this.mapping[i].globalCountryList.push(
                        {
                            'id': globalCountryList.countryId,
                            'itemName': globalCountryList.countryName
                        });
                    } 
                }
            } else{
                
                this.mapping[i].globalCountryList.push({id: 1, itemName: "All"})

            }


        });
    }

    getGlobalStateListNew(stateFilter,i){

        this.mapping[i].globalStateList=[];
        // this.commonService.getGlobalStateList(stateFilter).subscribe((result:any)=>{
         
        //     if(result.data.data.length > 0){ 
                
        //         this.mapping[i].globalStateList.push({id: 1, itemName: "All"})
        //         console.log('this.mapping[i]123',this.mapping[i].globalStateList)

        //         for (let globalStateList of result.data.data) {

        //             // if(globalStateList.stateId!=''  && globalStateList.stateId != 1){
        //                 if(globalStateList.stateId!=''&& globalStateList.continentId!=1){

        //                 this.mapping[i].globalStateList.push(
        //                 {
        //                     'id': globalStateList.stateId,
        //                     'itemName': globalStateList.stateName
        //                 });
        //             } 
        //         }
        //     }  else{
                
        //         this.mapping[i].globalStateList.push({id: 1, itemName: "All"})

        //     }


        // });
    }

    getGlobalCityListNew(cityFilter,i){
    
        this.mapping[i].globalCityList=[]; 
        // this.commonService.getGlobalCityList(cityFilter).subscribe((result:any)=>{
           
        //     if(result.data.data.length > 0){ 
                
        //         this.mapping[i].globalCityList.push({id: 1, itemName: "All"})
        //         console.log('this.mapping[i]123',this.mapping[i].globalCityList)

        //         for (let globalCityList of result.data.data) {

        //             // if(globalCityList.cityId!='' && globalCityList.cityId != 1){
        //                 if(globalCityList.cityId!=''&& globalCityList.continentId!=1){

        //                     this.mapping[i].globalCityList.push(
        //                     {
        //                         'id': globalCityList.cityId,
        //                         'itemName': globalCityList.cityName
        //                     });
        //             } 
        //         }

        //     }  else{
                
        //         this.mapping[i].globalCityList.push({id: 1, itemName: "All"})

        //     }

        // });
    }

    savecreateGeoZone(){ 


        console.log("this.createGeoZoneForm=true;",this.createGeoZoneForm.value);
        
        // this.loader = true;
        this.commonService.changeloader(true);

        this.isGeoZoneSubmitted=true;
        this.createGeoZoneForm.controls['mapGeoMapping'].setValue(this.variableForm.value.items);
        if(!this.createGeoZoneForm.valid){
            // this.loader = false;
            this.commonService.changeloader(false);
            return;
        }


        if(this.update == true){

            if(this.roleAsses.getGeoEdit == false){
                this.toastrService.success('no access to edit.');
                this.commonService.changeloader(false);
                return;
            }

            console.log(this.deleteGeoMapping)
            this.createGeoZoneForm.controls['deletedGeoMapping'].setValue(this.deleteGeoMapping);
            this.createGeoZoneForm.controls['id'].setValue(this.id);
            console.log(this.createGeoZoneForm.value);
            this.geoZoneService.updateGeoZone(this.createGeoZoneForm.value)
            .subscribe((result:any)=>{

                // this.loader=false;
                this.commonService.changeloader(false);

                // this.router.navigate(['master/geo_zone/list']);

                 //New Code for right side for from
                 this.update = false;
              //   this.updateSend.emit();
                 this.resetForm();
                 this.isGeoZoneSubmitted = false;
                 // this.addNewItemFlag=false;
                this.toastrService.success('Geo Zone  Updated Successfully.');
                console.log('this.result===>>>',result);

            })
        }

        if(this.update == false){

            if(this.roleAsses.geoZoneCreate == false){
                this.toastrService.success('no access to create.');
                this.commonService.changeloader(false);
                return;
            }

            this.createGeoZoneForm.value.id = undefined ;
            
            console.log(this.createGeoZoneForm);
            this.commonService.changeloader(false);

            
            this.geoZoneService.insertGeoZone(this.createGeoZoneForm.value)
            .subscribe((result:any)=>{

                // this.loader=false;
                this.commonService.changeloader(false);
                
                // this.router.navigate(['master/geo_zone/list']);

                 //New Code for right side for from
                 this.update = false;
               //  this.updateSend.emit();
                 this.resetForm();
                 this.isGeoZoneSubmitted = false;

                this.toastrService.success('Geo Zone Created Successfully.');
                console.log('this.result===>>>',result);
    
            })
            
        }
    }

    /*start dynamic add form fields */
    updateItem(task , i): FormGroup {


        console.log("task>>>",task );
        console.log("i>>>",i );


        this.mapping.push({
                globalContinentList:[],
                globalCountryList:[],
                globalStateList:[],
                globalCityList:[],
                startIP:'',
                endIP:'',
                subGeoZoneId:0,
                mappingId:null
            })
         
        

        if((task.continentId== "" && task.countryId== ""))
        {
            if((task.startIP=="" && task.endIP=="") || (task.startIP==null && task.endIP==null))
            {
                if(task.subGeoZoneId==0 || task.subGeoZoneId==null)
                {
                    task.continentId=[]; 
                    task.countryId=[];
                    task.startIP='';
                    task.endIP='';
                    task.subGeoZoneId=0;
                    // this.getGlobalContinentListNew({},0);
                    // this.getGlobalCountryListNew({},i);
                    // this.getGlobalStateListNew({},i);
                    // this.getGlobalCityListNew({},i);
                }
                else
                {  
                    task.continentId=[]; 
                    task.countryId=[];
                    task.startIP='';
                    task.endIP='';
                    // this.getGlobalContinentListNew({},0);
                    // this.getGlobalCountryListNew({},i);
                    // this.getGlobalStateListNew({},i);
                    // this.getGlobalCityListNew({},i);
                }
            }
            else{
                task.continentId=[]; 
                task.countryId=[];
                task.subGeoZoneId=0;
                // this.getGlobalContinentListNew({},0);
                // this.getGlobalCountryListNew({},i);
                // this.getGlobalStateListNew({},i);
                // this.getGlobalCityListNew({},i);
            }
        }else{

            // this.getGlobalContinentListNew({},0);
        
            // this.geoMappingFilter.continentId=task.continentId;
            // // this.getGlobalCountryListNew(this.geoMappingFilter,i);
        
            // this.geoMappingFilter.countryId=task.countryId;
            // this.getGlobalStateListNew(this.geoMappingFilter,i);
    

            // this.getGlobalCityListNew(this.geoMappingFilter,i);

            if(task.continentId == null){

                task.continentId=[];
            }
    
            if(task.countryId == null){
    
                task.countryId=[];
            }
    

            console.log("task>>",task);
            console.log("task>>",task.continentId);
            console.log("task>>",task.countryId);

            if(task.continentId!= 0 && this.globalContinentList.length>0){

                this.globalContinentList.forEach(element => {
                    if(element.id == task.continentId){
                        task.continentId=element;
                       
                    }      
                });
            }
            
            if(task.countryId!= 0 && this.globalCountryList.length>0){
    
                this.globalCountryList.forEach(element => {
                    if(element.id == task.countryId){
                        task.countryId=element;
                       
                    }      
                });
            }
            

        }

        console.log("task>>",task);

        return this.formBuilder.group({
            // continentId: [[task.continentId],Validators.required],
            // countryId: [[task.countryId],Validators.required],
            continentId: [[task.continentId]],
            countryId: [[task.countryId]],
            startIP:task.startIP,
            endIP:task.endIP,
            subGeoZoneId:task.subGeoZoneId,
            mappingId:task.mappingId
        });
    }

    createItem(): FormGroup {

        console.log("createItem 0");

        this.mapping.push({
            globalContinentList:[],
            globalCountryList:[],
            startIP:'',
            endIP:'',
            subGeoZoneId:0,
            mappingId:null 
        })

        // var obj = {
        //     id: 1,
        //     itemName: "All"
        // }

        return this.formBuilder.group({
            continentId: [[]],
            countryId: [[]],
            startIP:'',
            endIP:'',
            subGeoZoneId:0,
            mappingId:null 
        });
    }

    createItemAfter(): FormGroup {

        // var obj = {
        //     id: 1,
        //     itemName: "All"
        // }

        console.log("createItemAfter 1");
        return this.formBuilder.group({
            continentId: [[]],
            countryId: [[]],
            startIP:'',
            endIP:'',
            subGeoZoneId:0,
            mappingId:null 
        });
    }

    addItem(): void {

        console.log("addItem 1");
             
        this.mapping.push({
            globalContinentList:[],
            globalCountryList:[],
            startIP:'',
            endIP:'',
            subGeoZoneId:0 ,
            mappingId:null 
        })
        if(this.geoZoneFormData.length) {
        this.geoZoneFormData.push({
            continentId: [],
            countryId: [],
            startIP:'',
            endIP:'',
            subGeoZoneId:0,
            addNewItemFlag:true,
            startIPCheckError:false,
            endIPCheckError:false,
            startIPRangeCheckError:false,
            endIPRangeCheckError:false,
            geoMappingSelectionFlag:false
        });
    }
        // if(this.update)
        //     this.addNewItemFlag=true;
        this.items = this.variableForm.get('items') as FormArray;
        this.items.push(this.createItemAfter());

    }

    delInput(index){
        const arrayControl = this.variableForm.get('items') as FormArray;
        arrayControl.removeAt(index);
        this.deleteGeoMapping.push(this.geoZoneFormData[index].mappingId);
        this.geoZoneFormData.splice(index,1);
        console.log(this.geoZoneFormData)
        arrayControl.length == 0
    }
    /* end dynamic add form fields */

    isDeleteGeoMapping(event){

        console.log('event Mayuri',event)
        if(event=='Cancel'){
            this.isDeleteAction=false;
        }
        
        if(event=='Yes'){
            this.isDeleteAction=false;
            this.delInput(this.deleteGeoMappingIndex);
        }

    }

    isDeleteGeoMappingYes(i){
        this.deleteGeoMappingIndex = i;
    }


    //New Code for right side for from
    onContentReadyToReview(){
      //  this.commonService.changeloader(true);  
       // this.loader = true
        console.log("variableForm>>",this.variableForm.value.items.length);
        if(this.createGeoZoneForm.invalid){

            this.contentReadyToReview = false;
            this.isGeoZoneSubmitted = true;
            this.commonService.changeloader(false);  
this.loader= false
            return;
        }
        else{

          //  let checkIPRangeFlag=this.checkIPRange();
            this.contentReadyToReview = true;
            this.shareMassage = 'review';
    
           this.isGeoZoneSubmitted=true;
           this.loader= false
           return;
            
        }
    
    }

    isContentReadyToReviewReceived(event){

        console.log("we are in",event);
        this.contentReadyToReview = false;

       //New Code start
        if(event == 'No'){

            this.contentReadyToReview = false;
           
        }
        //New Code end

        if(event == 'Yes'){

            this.createGeoZoneForm.controls['contentState'].setValue(['Completed']);
            this.savecreateGeoZone();
           
        }
        if(event == 'Cancel'){

            this.createGeoZoneForm.controls['contentState'].setValue(['In-Progress']);
            this.savecreateGeoZone();
            
        }
       
    }

    resetForm(){

        //code for global loader start
        this.commonService.changeloader(false);
        //code for global loader end
        // this.img = [];
        // this.spinnerService.hide();
        // this.uploadImgFilePath=[];
        this.update = false;
        this.isGeoZoneSubmitted = false;

        this.updateSend.emit();
    
        // const arrayControl = this.multipleDeviceForm.get('devices') as FormArray;
        // while (arrayControl.length !== 0) {

        //     arrayControl.removeAt(0);
        // }

        this.createGeoZoneForm = this.formBuilder.group({
            geoZoneName:['', Validators.compose([Validators.required])],
            // latitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            latitude:[''],
            // mapAssetGroup:[[]],
            longitude:[''],
            // longitude:['',Validators.pattern('[1-9]+(\.[0-9]+)?')],
            description:[''],
            isActive:['1'],
            mapGeoMapping:[[]],
            deletedGeoMapping:[[]],
            id:[''],
            contentState:['In-Progress'],
            publisherState:['Un-published'],
            reviewerState:['Un-approved'],
            created_by:[localStorage.getItem('ud')]
            // geoMappingArray: this.formBuilder.array([ this.createGeoMappingItem() ])
        });
        
        //reset multiselect list
        // this.selectedGeoZone=[];
        // this.selectedProductlist=[];

        //reset device type image
        // let obj = {
        //     'index':'',
        //     'deviceType':'',
        //     'selectedFiles':'',
        //     'fileName': '',
        //     'filePath': "",
        //     'fileType':''
        // }

       

        //     this.img.push({
        //         imgUrl:''
        //     })

        this.update = false;

        // this.multipleDeviceForm = this.formBuilder.group({

        //     devices: this.formBuilder.array([this.createItem()])

        // });
        
        this.showCreateNewButton('show');

    }

    showCreateNewButton(isShow){
        if(isShow == 'show'){
            this.isCreateNewShow = true;
        }
        else{
            this.isCreateNewShow = false;
        }
    }
    checkIP(ipValue,i,type)
    {
        let obj=this.variableForm.get('items') as FormArray;
        console.log(obj.controls.length);
        console.log(obj.controls[0].value);
        console.log(ipValue);
        console.log(this.geoZoneFormData[i]);
        if(type=="start")
        {
            this.geoZoneFormData[i]['startIPCheckError']=false;
            this.geoZoneFormData[i]['startIPRangeCheckError']=false;
        }
        if(type=="end")
        {
            this.geoZoneFormData[i]['endIPCheckError']=false;
            this.geoZoneFormData[i]['endIPRangeCheckError']=false;
        }
        let regexpNumber = new RegExp("^(?=.*[^\.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$");
        console.log(regexpNumber.test(ipValue));
        if(!(regexpNumber.test(ipValue)))
        {
            if(type=="start")
                this.geoZoneFormData[i]['startIPCheckError']=true;
            if(type=="end")
                this.geoZoneFormData[i]['endIPCheckError']=true;
            console.log(this.geoZoneFormData[i]);
        }
        // if(!(this.geoZoneFormData[i]['startIPCheckError'] && this.geoZoneFormData[i]['endIPCheckError']))
        // {
        //     if(type=="start")
        //     {
        //         var startIP=ipValue.split(".");
        //         var startIPNumber=(startIP[0]*16777216)+(startIP[1]*65536)+(startIP[2]*256)+startIP[3];
        //         var existsStartIP:any;
        //         var existsStartIPNumber;
        //         var existsEndIP:any;
        //         var existsEndIPNumber;
        //         for (var j = 0; j < obj.controls.length; j++) {
        //             if(obj.controls[j].value.startIP && j!=i)
        //             {
        //                 existsStartIP=obj.controls[j].value.startIP.split(".");
        //                 existsStartIPNumber=(existsStartIP[0]*16777216)+(existsStartIP[1]*65536)+(existsStartIP[2]*256)+existsStartIP[3];
        //                 existsEndIP=obj.controls[j].value.endIP.split(".");
        //                 existsEndIPNumber=(existsEndIP[0]*16777216)+(existsEndIP[1]*65536)+(existsEndIP[2]*256)+existsEndIP[3];
        //                 if((startIPNumber == existsStartIPNumber) || (startIPNumber >= existsStartIPNumber && startIPNumber <= existsEndIPNumber))
        //                 {
        //                     this.geoZoneFormData[i]['startIPRangeCheckError']=true;
        //                 }
        //             }
        //         }
        //     }
        //     else{
        //         var endIP=ipValue.split(".");
        //         var endIPNumber=(endIP[0]*16777216)+(endIP[1]*65536)+(endIP[2]*256)+endIP[3];
        //         console.log(ipValue);
        //         console.log(endIPNumber);
        //         var existsStartIP:any;
        //         var existsStartIPNumber;
        //         var existsEndIP:any;
        //         var existsEndIPNumber;
        //         console.log("inside loop");
        //         for (var j = 0; j < this.geoZoneFormData.length; j++) {
        //             if(obj.controls[j].value.endIP && j!=i)
        //             {
        //                 console.log(j);
        //                 console.log(obj.controls[j].value.startIP);
        //                 console.log(obj.controls[j].value.endIP);
        //                 existsStartIP=obj.controls[j].value.startIP.split(".");
        //                 existsStartIPNumber=(existsStartIP[0]*16777216)+(existsStartIP[1]*65536)+(existsStartIP[2]*256)+existsStartIP[3];
        //                 console.log(existsStartIPNumber);
        //                 existsEndIP=obj.controls[j].value.endIP.split(".");
        //                 existsEndIPNumber=(existsEndIP[0]*16777216)+(existsEndIP[1]*65536)+(existsEndIP[2]*256)+existsEndIP[3];
        //                 console.log(existsEndIPNumber);
        //                 if((endIPNumber == existsEndIPNumber) || (endIPNumber >= existsStartIPNumber && endIPNumber <= existsEndIPNumber))
        //                 {
        //                     this.geoZoneFormData[i]['endIPRangeCheckError']=true;
        //                 }
        //             }
        //         }
        //         console.log(this.geoZoneFormData[i]['endIPRangeCheckError']);
        //     }
        // }   
        // console.log(this.ipCheckError);
    }
    checkIPRange()
    {
        var existsStartIP:any;
        var existsStartIPNumber;
        var existsEndIP:any;
        var existsEndIPNumber;
        let obj=this.variableForm.get('items') as FormArray;
        console.log(obj);
        let returnFlag:boolean = false;
        for (var i = 0; i < obj.controls.length; i++) {
            if(obj.controls[i].value.startIP)
            {
                var startIP=obj.controls[i].value.startIP.split(".");
                var startIPNumber=(startIP[0]*16777216)+(startIP[1]*65536)+(startIP[2]*256)+startIP[3];
                var endIP=obj.controls[i].value.endIP.split(".");
                var endIPNumber=(endIP[0]*16777216)+(endIP[1]*65536)+(endIP[2]*256)+endIP[3];
                for (var j = 0; j < obj.controls.length; j++) {
                    if(obj.controls[j].value.startIP && j!=i)
                    {
                        existsStartIP=obj.controls[j].value.startIP.split(".");
                        existsStartIPNumber=(existsStartIP[0]*16777216)+(existsStartIP[1]*65536)+(existsStartIP[2]*256)+existsStartIP[3];
                        existsEndIP=obj.controls[j].value.endIP.split(".");
                        existsEndIPNumber=(existsEndIP[0]*16777216)+(existsEndIP[1]*65536)+(existsEndIP[2]*256)+existsEndIP[3];
                      //  console.log(startIPNumber == existsStartIPNumber);
                      //  console.log((startIPNumber == existsStartIPNumber) || (startIPNumber >= existsStartIPNumber && startIPNumber <= existsEndIPNumber));
                        if((startIPNumber == existsStartIPNumber))
                        {
                            console.log(existsStartIPNumber,i, startIPNumber);
                            this.geoZoneFormData[i]['startIPRangeCheckError']=true;
                            returnFlag=true;
                        }
                        if((endIPNumber == existsEndIPNumber))
                        {
                            this.geoZoneFormData[i]['endIPRangeCheckError']=true;
                            returnFlag=true;
                        }
                    }
                }
            }
        }
        return returnFlag;
    }
    updateFilter(event){
        let regexpNumber = new RegExp("^(?=.*[^\.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$");
         this.filtergeoObj ={ ip : event.target.value};
        if(regexpNumber.test(event.target.value)){
            this.getGeoZoneInfo(this.id,true,0,10)
            this.searcherrormsg=false
        }else{
            this.searcherrormsg=true
        }
    }

    clearsearch(){
        (<HTMLInputElement>document.getElementById('searchvalue')).value = null;
        console.log(document.getElementById('searchvalue'))
         this.filtergeoObj ={};
         this.getGeoZoneInfo(this.id,false,0,10)
         this.searcherrormsg=false
    }

}
